<template>
    <div>
        <div>
            <dl v-if="showonece">
                <dt><img :src="data.productPic" alt=""></dt>
                <dd>
                <p class="Name">{{data.productName }}</p>
                <p class="productSubTitle ">{{data.productAttr}}</p>
                <div style="display:flex;justify-content: space-between;align-items:baseline ;">
                    <p class="price ">￥{{data.productPrice }}</p>
                    <div style="display:flex;justify-content: space-between;" class="between">
                        <button @click="subtraction(data.id)" disabled class="btnStyle" style="border-right:none;">－</button>
                        <van-field v-model="data.productQuantity" type="digit" disabled class="digit" input-align="center" />
                        <button  @click="addition(data.id)" disabled  class="btnStyle" style="border-left:none;">＋</button>
                    </div>
                    </div>
                </dd>
            </dl>
            <div v-else>
              <dl v-for="(item,index) in dataArrey" :key="index">
                  <dt><img :src="item.productPic" alt=""></dt>
                  <dd>
                  <p class="Name">{{item.productName }}</p>
                  <p class="productSubTitle ">{{item.productAttr}}</p>
                  <div style="display:flex;justify-content: space-between;align-items:baseline ;">
                      <p class="price ">￥{{item.productPrice }}</p>
                      <div style="display:flex;justify-content: space-between;" class="between">
                          <button @click="subtraction(item.id)" disabled class="btnStyle" style="border-right:none;">－</button>
                          <van-field v-model="item.productQuantity" type="digit" disabled class="digit" input-align="center" />
                          <button  @click="addition(item.id)" disabled  class="btnStyle" style="border-left:none;">＋</button>
                      </div>
                      </div>
                  </dd>
              </dl>
            </div>
        </div>
        <div class="cart_bgc"></div>
        <div class="cart_cell">
          <van-cell :title="Eaction" is-link  @click="showPicker = true"  />
      </div>
      <div style="border:0.5px solid #F2F2F2;margin-top:6px;"></div>
      <div class="ref_miao">
          <p>详细描述</p>
          <div class="ref_textarea">
            <van-field
                v-model="message"
                type="textarea"
                maxlength="200"
                placeholder="为尽快处理您的售后申请，请填写详细描述（0 - 200 字）"
                show-word-limit
                />
          </div>
      </div>
      <div style="margin-bottom:10vh;">
          <p style="margin:10px" class="ref_P">上传图片(最多4张)</p>
          <div style="margin-top:20px;width:96%;margin:0 auto;display: flex;justify-content: flex-start;" class="ref_Photo">
            <!-- <div class="posting-uploader-item" v-for="(item,index) in postData" :key="index">
              <img :src="item"  alt="图片" class="imgPreview"  @click="ImagePreviewClick(index)">
              <van-icon name="close" @click="delImg(index)" class="delte"/>
            </div> -->
              <van-uploader  multiple :max-count="4" @delete="beforedelete" v-model="fileList" :after-read="afterRead"  />
          </div>
      </div>
      <div class="absolute">
        <van-button type="primary" @click="lowerover" :disabled="disabledover" block>下一步</van-button>
      </div>
        <van-popup v-model="showPicker" position="bottom">
        <van-picker
            show-toolbar
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
        />
        </van-popup>
    </div>
</template>
<script>
import { compressImage } from '../CommodityEvaluation/compressImage'
import { Field, Cell, Picker, Popup, Uploader, Icon, Toast, Button, ImagePreview } from 'vant'
import { afterProductSubmit, afterOrderSubmit } from '@/request/api'
export default {
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [ImagePreview.name]: ImagePreview
  },
  data() {
    return {
      data: {},
      Eaction: '请选择原因',
      showPicker: false,
      columns: ['请选择原因', '不想买了', '商品买错（颜色、尺寸选错）', '地址写错', '忘记使用优惠券'],
      message: '',
      postData: [],
      fileList: [],
      disabledover: true,
      showonece: false,
      dataArrey: [],
      show: true,
      time: ''
    }
  },
  methods: {
    onConfirm(value) {
      // disabledover
      this.Eaction = value
      console.log(value)
      if (this.Eaction !== '请选择原因') {
        this.disabledover = false
      } else {
        this.disabledover = true
      }
      this.showPicker = false
    },
    // 删除图片
    beforedelete(file, detail) {
      this.postData.splice(detail.index, 1)
      // this.fileList.splice(detail.index, 1)
      console.log(this.postData)
      console.log(this.fileList)
    },
    lowerover() {
      this.time = setTimeout(() => {
        if (this.showonece) {
          console.log(this.data)
          const params = {
            orderItemId: this.data.id,
            reason: this.Eaction,
            description: this.message,
            pic: this.postData.join(','),
            productCount: this.data.productQuantity,
            type: 2
          }
          console.log(params)
          afterProductSubmit(params).then(res => {
            console.log(res)
            if (res.code === 200) {
              // 多商品
              if (this.showonece === false) {
                this.$router.push({ path: '/Speed', query: { id: res.data, MultiCommodity: 2 } })
              } else {
                // 单商品
                this.$router.push({ path: '/Speed', query: { id: res.data } })
              }
              Toast('已提交申请退款')
              // this.$router.push({ path: '/Speed', query: { id: res.data } })
            } else {
              Toast(res.message)
            }
          }).catch(res => {
            console.log(res)
          })
        } else {
          var Arreyform = JSON.parse(this.$route.query.orderlistdata)
          console.log(Arreyform.id)
          const params = {
            orderId: Arreyform.id,
            reason: this.Eaction,
            description: this.message,
            pic: this.postData.join(',')
          }
          console.log(params)
          afterOrderSubmit(params).then(res => {
            console.log(res)
            if (res.code === 200) {
              // 多商品
              if (this.showonece === false) {
                this.$router.push({ path: '/Speed', query: { id: res.data, MultiCommodity: 2 } })
              } else {
                // 单商品
                this.$router.push({ path: '/Speed', query: { id: res.data } })
              }
              Toast('已提交申请退款')
            } else {
              Toast(res.message)
            }
          }).catch(res => {
            console.log(res)
          })
        }
      }, 800)
    },
    afterRead (file, detail) {
      console.log(this.arr)
      const ua = navigator.userAgent.toLowerCase()
      // Android终端
      const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
      // Ios终端
      const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      console.log(isiOS, isAndroid)
      //   if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //     // kInputFromiOS('login')
      //   } else if (/(Android)/i.test(navigator.userAgent)) {
      //     console.log('传递参数安卓')
      //     var message = {
      //       body: 'camera'
      //     }
      //     var jsonStr = JSON.stringify(message)
      //     window.android.getDataFormVue(jsonStr)
      //   }
      var that = this
      console.log(file)
      const OSS = require('ali-oss')
      // base64格式的图片文件
      var urlData = file.content
      //   console.log(urlData)

      compressImage(urlData, {
        width: 200,
        quality: 0.7
      }).then(result => {
        urlData = result
      })
      console.log(this.arr)

      const base64 = urlData.split(',').pop()

      const fileType = urlData
        .split(';')
        .shift()
        .split(':')
        .pop()
      function toBlob (urlData, fileType) {
        const bytes = window.atob(urlData)
        let n = bytes.length
        const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bytes.charCodeAt(n)
        }
        return new Blob([u8arr], { type: fileType })
      }
      console.log(this.postData)
      // base64转blob
      const blob = toBlob(base64, fileType)
      // blob转arrayBuffer
      const reader = new FileReader()
      reader.readAsArrayBuffer(blob)
      reader.onload = function (event) {
        console.log(event)
        const client = new OSS({
          region: 'oss-cn-beijing',
          endpoint: 'vue.soujingpin.com',
          accessKeyId: 'LTAI4FoC2pB7aGMSbj6WFith',
          accessKeySecret: 'sETV8g6QhzNj87ebibWEkzxNf2tMvr',
          bucket: 'soujingpin-vue-3fang',
          cname: true
        })
        // console.log(client)
        // 文件名:图片名字加上时间戳和9999以内随机数，防止重名
        const objectKey = `/gjdw/${new Date().getTime()}${Math.floor(
          Math.random() * 10000
        )}${file.file.name}`
        // arrayBuffer转Buffer
        const buffer = new OSS.Buffer(event.target.result)
        // 上传
        client
          .put(objectKey, buffer)
          .then(function (result) {
            that.postData.push(result.url) // 上传一张之后压入这个数组
            console.log(that.postData)
            // a++
            // console.log(a)
            // if (a === 4) {
            //   that.show = false
            // }
            // console.log(that.postData)
            // for (var i = 0; i < 5; i++) {
            //   if (a === i) {
            //     that.postData.push(result.url)
            //     console.log(that.postData)
            //   }
            // }
          })
          .catch(function (err) {
            console.log('cuowu', err)
            Toast('上传图片失败')
          })
      // console.log(that.arr)
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.time)
  },
  created() {
    if (this.$route.query.data) {
      console.log(111)
      this.showonece = true
      this.data = JSON.parse(this.$route.query.data)
      console.log(this.data)
      console.log(this.$route.query.orderId)
    } else {
      console.log(22)
      this.showonece = false
      var dataArreyform = JSON.parse(this.$route.query.orderlistdata)
      this.dataArrey = dataArreyform.orderItemList
      console.log(JSON.parse(this.$route.query.orderlistdata))
    }
  }
}
</script>
<style lang="less" scoped>
.cart_bgc{
    background-color: #F2F2F2;
    height: 25px;
}
dl{
    margin-left: 30px;
    height: 198px;
    dt{
      margin-top: 28px;
      width: 150px;
      height: 150px;
      float: left;
      margin-right: 24px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    dd{
      margin-top: 38px;
      float: left;
      width: 450px;
      .Name{
        height: 36px;
        margin-top: 2%;
        font-size: 28px;
        color: #333333;
        //多行文本溢出隐藏
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .productSubTitle{
        color: #666666;
        margin-top: 6px;
      }
      .price {
        margin-top: 8px;
        color: #333333;
        font-size: 28px;
      }
      .discountPrice {
        margin-top: 5px;
        padding: 0px 15px;
        color: #DB5E22;
        // width:122px;
        height:36px;
        background:rgba(255,239,227,1);
        border-radius:4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
      }
    }
  }
    .digit /deep/ .van-field__body input {
      line-height: normal;
    }
    .digit{
      line-height: 83px;
      font-size: 28px;
      padding: 0px;
      width: 76px;
      height: 51px;
      border-top: 1px solid rgba(220,220,220,1);/*no*/
      border-bottom: 1px solid rgba(220,220,220,1);/*no*/
    }
    /deep/ .van-cell__value {
      width: 100%;
      height: 100%;
    }
    .digit /deep/ .van-field__body {
      width: 100%;
      height: 100%;
    }
    .btnStyle{
      width:84px;
      height:51px;
      border:1px solid rgba(220,220,220,1); /*no*/
      border-radius:4px 0px 0px 4px;
      display: flex;
      justify-content: center;
      align-items:center ;
      background-color: #fff;
    }
    .cart_cell{
        height: 60px;
    }
    .cart_cell .van-cell {
        line-height: 45px;
        font-size: 28px;
        padding-left: 30px;
    }
    .van-cell__left-icon, .van-cell__right-icon{
        line-height: 60px;
    }
    /deep/.van-picker__toolbar{
        height: 80px;
        line-height: 80px;
        button{
            font-size: 28px;
        }
    }
    /deep/.van-picker-column{
        font-size: 32px;
    }
    .ref_miao{
        margin-top: 20px;
        margin-left: 30px;
        font-size: 28px;
        p{
            margin: 15px 0;
        }
    }
    .ref_textarea{
        width:690px;
        height:260px;
        border:1px solid rgba(153,153,153,1);/*no*/
        border-radius:8px;
        box-sizing: border-box;
        padding-left: 10px;
        /deep/ textarea{
            height: 100%;
            font-size: 25px;
        }
    }
    /deep/.van-field__word-limit{
        margin-top: 10px;
    }
    /deep/ .van-field__body{
        height: 200px;
    }
    .ref_P{
        font-size: 26px;
    }
    .ref_Photo{
        .posting-uploader-item {
            width: 150px;
            height: 150px;
            position: relative;
            margin-right: 20px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .pf{
            font-size: 26px;
            margin-right: 20px;
        }
        /deep/ .van-field__control{
            font-size: 25px;
        }
        /deep/ .delte{
            position: absolute;
            top: -13px;
            right: -10px;
            z-index: 999;
        }
        /deep/ .van-uploader{
            margin-left: 10px;
        }
        .imgPreview{
            margin-right: 20px;
        }
    }
    /deep/ .van-uploader__preview {
        width: 150px;
        height: 150px;
        margin-left: 10px;
        .van-uploader__preview-image{
            width: 100%;
            height: 100%;
        }
    }
    /deep/ .van-uploader__upload{
        width: 150px;
        height: 150px;
        margin-left: 10px;
    }
    /deep/ .van-uploader__preview-delete{
        font-size: 35px;
    }
    /deep/ .van-uploader__upload-icon {
        font-size: 50px;
    }
    /deep/ .van-image__error-icon {
        font-size: 50px;
    }
    /deep/.van-button--primary {
        background-color: #B4272D;
        border:#B4272D 1px solid;
        position: absolute;
        bottom: 0px;
        height: 70px;
        font-size: 28px;
    }
    .absolute {
      width: 100%;
      position: fixed;
      bottom: 0;
      height:70px;
      background:rgba(255,255,255,1);
      display: flex;
      justify-content: space-between;
      align-items: baseline ;
    }
    /deep/ .van-uploader__preview{
      margin-left: 15px;
    }
</style>
